import { parseInventoryQuantity } from '../../../../../utils/inventoryInputs';
import { convertPoundsToUah, parseMoneyAmount } from '../../../../../utils/productPrice';
import { DEFAULT_COL, DEFAULT_PARSE_ROWS, UNMAPPED } from './constants';

export const normalizeCell = (v) => {
  if (v == null) return '';
  if (typeof v === 'string') return v.trim();
  return String(v).trim();
};

export const colIdxToOption = (idx, maxCols) => (idx >= 0 && idx < maxCols ? String(idx) : UNMAPPED);

export const buildColumnLabels = (colCount) => {
  const labels = [];
  for (let i = 0; i < colCount; i++) {
    let n = i;
    let s = '';
    do {
      s = String.fromCharCode(65 + (n % 26)) + s;
      n = Math.floor(n / 26) - 1;
    } while (n >= 0);
    labels.push(s);
  }
  return labels;
};

/** @deprecated Prefer parseMoneyAmount from utils/productPrice */
export const parsePriceInPounds = parseMoneyAmount;

export const parseQuantity = raw => {
  const text = normalizeCell(raw);
  return text ? parseInventoryQuantity(text, { allowZero: true }) : 0;
};

export const buildColumnHeaders = (rows, maxCols, skipRows) => {
  if (!rows.length || maxCols <= 0) return [];
  const labels = buildColumnLabels(maxCols);
  const skip = Math.max(0, Math.min(Number(skipRows) || 0, rows.length - 1));
  const sampleRow = rows[skip] || [];
  return labels.map((lbl, idx) => {
    const sample = normalizeCell(sampleRow[idx]);
    return sample ? `${lbl}: ${sample}` : lbl;
  });
};

export const getDefaultColumnIndices = (maxCols) => ({
  nameColIdx: colIdxToOption(DEFAULT_COL.name, maxCols),
  articleColIdx: colIdxToOption(DEFAULT_COL.article, maxCols),
  barcodeColIdx: colIdxToOption(DEFAULT_COL.barcode, maxCols),
  priceColIdx: colIdxToOption(DEFAULT_COL.price, maxCols),
  quantityColIdx: colIdxToOption(DEFAULT_COL.quantity, maxCols)
});

export const buildBulkCreateItemsFromRows = ({
  rows,
  maxCols,
  skipRows,
  parseRows,
  nameColIdx,
  articleColIdx,
  barcodeColIdx,
  priceColIdx,
  quantityColIdx,
  poundRate
}) => {
  if (!rows.length || maxCols <= 0) return [];

  const skip = Math.max(0, Math.min(Number(skipRows) || 0, rows.length));
  let dataRows = rows.slice(skip);
  const limit = parseRows !== '' && Number(parseRows) > 0 ? Number(parseRows) : dataRows.length;
  dataRows = dataRows.slice(0, limit);

  const nIdx = nameColIdx === UNMAPPED ? -1 : Number(nameColIdx);
  const aIdx = articleColIdx === UNMAPPED ? -1 : Number(articleColIdx);
  const bIdx = barcodeColIdx === UNMAPPED ? -1 : Number(barcodeColIdx);
  const pIdx = priceColIdx === UNMAPPED ? -1 : Number(priceColIdx);
  const qIdx = quantityColIdx === UNMAPPED ? -1 : Number(quantityColIdx);

  if (nIdx < 0 || aIdx < 0) return [];

  const list = [];
  for (let i = 0; i < dataRows.length; i++) {
    const r = dataRows[i];
    const name = normalizeCell(r[nIdx]);
    const productCode = normalizeCell(r[aIdx]);
    if (!name && !productCode) continue;

    const barcode = bIdx >= 0 ? normalizeCell(r[bIdx]) : '';
    const priceInPounds = pIdx >= 0 ? parsePriceInPounds(r[pIdx]) : null;
    const quantity = qIdx >= 0 ? parseQuantity(r[qIdx]) : 0;
    const price = convertPoundsToUah(priceInPounds, poundRate);

    list.push({
      key: `${i}-${productCode || name}`,
      name,
      productCode,
      barcode: barcode || '',
      priceInPounds,
      price,
      quantity: quantity == null ? normalizeCell(r[qIdx]) : quantity,
      categoryIds: [],
      selected: true
    });
  }
  return list;
};

export const selectInputOnFocus = (e) => e.target.select();

export const normalizeSkipRowsInput = (raw, fallback = '2') => {
  if (raw === '' || raw == null) return fallback;
  const n = parseInt(String(raw), 10);
  return String(Number.isFinite(n) && n >= 0 ? n : fallback);
};

export const normalizeParseRowsInput = (raw, fallback = String(DEFAULT_PARSE_ROWS)) => {
  if (raw === '' || raw == null) return fallback;
  const n = parseInt(String(raw), 10);
  if (!Number.isFinite(n) || n < 1) return fallback;
  return String(n);
};
